import {CommonModule} from "@angular/common";
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Pipe({ name: 'dateByTimeZone' })
export class DateByTimeZone implements PipeTransform 
{
  /** * * @param value * @returns {string} */
  transform(value: any, offset?: any, timeFormat?:any): any 
  {   

    return moment(value).utc().utcOffset(offset*60).format(timeFormat);
  }
}
